import Cookies from "js-cookie";

// Function to get JWT token
export const getToken = () => localStorage.getItem("accessToken");

// Function to get username from cookies
export const getUsername = () => Cookies.get("username");

// Function to remove authentication data
export const logout = () => {
    localStorage.removeItem("accessToken");
    Cookies.remove("username");
    window.location.href = "/login"; // Redirect to login page
};

export const getDecodedToken = () => {
    const token = getToken();
    if (!token) return null;

    try {
        // JWT tokens are base64 encoded and have 3 parts separated by dots
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};
